import {
  BoardSearchResult,
} from "../../assets/GlobalStyles";
import Select from "react-select";
import Table from "../../components/table";

import React, {useEffect, useState} from "react";
import {atom, useAtom} from "jotai";
import {dataTotalInfo} from "../../components/common/entity";
import CreateAdminModal from "../../components/common/CreateAdminModal";
import SelectAdminModal from "../../components/common/SelectAdminModal";
import {selAdminList} from "../../services/Platform/ManageAdminAxios";
import {
  columnAdminData,
  searchAccountInfo,
  selectAccountUseInfo
} from "./entity/Common";
import styled from "styled-components";
import PlatformSectionHeader from "./PlatformSectionHeader";

const UserInfoList = atom([])
const adminSelectStyle = {
  control: (provided, state) => ({
    ...provided,
    width: "100%",
    minHeight: 42,
    height: 42,
    borderColor: state.isFocused ? "#f5811f" : "#dfe3e6",
    borderRadius: 8,
    backgroundColor: "#fff",
    boxShadow: state.isFocused ? "0 0 0 3px rgba(245,129,31,.13)" : "none",
    fontSize: 13,
    cursor: "pointer",
    "&:hover": {borderColor: "#f1b786"}
  }),
  valueContainer: provided => ({...provided, height: 42, padding: "0 12px"}),
  input: provided => ({...provided, margin: 0, padding: 0}),
  indicatorsContainer: provided => ({...provided, height: 42}),
  indicatorSeparator: () => ({display: "none"}),
  dropdownIndicator: provided => ({...provided, padding: "0 10px", color: "#777"}),
  singleValue: provided => ({...provided, color: "#333", fontWeight: 700}),
  menu: provided => ({...provided, zIndex: 40, overflow: "hidden", border: "1px solid #e5e8eb", borderRadius: 8, boxShadow: "0 8px 24px rgba(0,0,0,.1)"}),
  option: (provided, state) => ({...provided, padding: "10px 12px", backgroundColor: state.isSelected ? "#fff4e8" : state.isFocused ? "#fffaf6" : "#fff", color: state.isSelected ? "#d96500" : "#555", fontSize: 13, fontWeight: state.isSelected ? 700 : 500, cursor: "pointer"})
}
export default function PlatformAdmin(){
  const [isConditionOpen, setIsConditionOpen] = useState(false)
  const [searchAccountInfoState ,setSearchAccountInfoState] = useState(searchAccountInfo)
  const [accountUseYnState]=useState(selectAccountUseInfo)
  const [userInfoList, setUserInfoList] = useAtom(UserInfoList)
  const [totalInfo,setTotalInfo] = useState(dataTotalInfo)

  useEffect(()=>{
    selAdminList(searchAccountInfoState).then(response =>{
      if(response !== null){
        setUserInfoList(response?.content)
        setTotalInfo({
          totalCount: response?.totalElements,
          totalPages: response?.totalPages,
          currentPage:response?.pageNumber
        })
      }
    })
  },[])

  /**
   * 매체 타입 변경
   * @param mediaType
   */
  const handleMediaType =(mediaType) =>{
    setSearchAccountInfoState({
      ...searchAccountInfoState,
      mediaType: mediaType.value
    })
  }


  /**
   * 검색 타입 선택
   * @param mediaSearchType
   */
  const handleMediaSearchType =(mediaSearchType) =>{
    setSearchAccountInfoState({
      ...searchAccountInfoState,
      mediaSearchType: mediaSearchType.value,
      siteName: mediaSearchType.value !== null ? searchAccountInfoState.siteName : '',
      username: mediaSearchType.value !== null ? searchAccountInfoState?.username: '',
      phoneNumber: mediaSearchType.value !== null ? searchAccountInfoState.phoneNumber: '',
      searchText: mediaSearchType.value !== null ? searchAccountInfoState?.searchText: ''
    })
  }
  /**
   * 계정 사용여부
   * @param accountUseYn
   */
  const handleSelectAccountUseYn =(activeYn) =>{
    setSearchAccountInfoState({
      ...searchAccountInfoState,
      activeYn: activeYn.value
    })
  }
  /**
   * 검색버튼
   */
  const searchUserList =(condition = searchAccountInfoState) =>{
    selAdminList(condition).then(response =>{
      if(response){
        setUserInfoList(response?.content)
        setTotalInfo({
          totalCount: response?.totalElements,
          totalPages: response?.totalPages,
          currentPage:response?.pageNumber
        })
      }
    })
  }

  const resetSearchCondition = () => {
    const resetState = {...searchAccountInfo}
    setSearchAccountInfoState(resetState)
    searchUserList(resetState)
  }

  const handleAdminRowClick = (...args) => {
    const eventArg = args.find(arg => arg?.target || arg?.nativeEvent?.target || arg?.event?.target)
    const target = eventArg?.target ?? eventArg?.nativeEvent?.target ?? eventArg?.event?.target

    if (!target || typeof target.closest !== 'function' || target.closest('button')) return

    const row = target.closest('.InovuaReactDataGrid__row')
    row?.querySelector('button[data-admin-detail="true"]')?.click()
  }

  const handleAdminUpdated = updatedAdmin => {
    setUserInfoList(currentList => (
        Array.isArray(currentList)
            ? currentList.map(admin => (
                (admin.id && admin.id === updatedAdmin.id)
                || admin.email === updatedAdmin.email
                    ? {...admin, ...updatedAdmin}
                    : admin
            ))
            : currentList
    ))
    searchUserList()
  }

  const adminColumns = columnAdminData.map(column => (
      column.name === 'email'
          ? {
            ...column,
            render: ({value, data}) => (
                <SelectAdminModal
                    formType="admin"
                    title="관리자 정보"
                    buttonText={value}
                    data={data}
                    onClick={handleAdminUpdated}
                />
            )
          }
          : column
  ))

  /**
   * 검색어 입력
   * @param event
   */
  const handleSearchName =(event) =>{
    if(searchAccountInfoState.mediaSearchType ==='MEDIA_NAME'){
      setSearchAccountInfoState({
        ...searchAccountInfoState,
        siteName: event.target.value,
        username:'',
        phoneNumber:'',
        searchText:event.target.value
      })
    }else if(searchAccountInfoState.mediaSearchType ==='MEDIA_ID'){

      setSearchAccountInfoState({
        ...searchAccountInfoState,
        username: event.target.value,
        siteName: '',
        phoneNumber:'',
        searchText:event.target.value
      })
    }else if(searchAccountInfoState.mediaSearchType ==='PHONE'){
      setSearchAccountInfoState({
        ...searchAccountInfoState,
        siteName: '',
        username:'',
        phoneNumber: event.target.value,
        searchText:event.target.value
      })
    }
  }
  return(<AdminManageCards>
    <AdminCard $condition>
      <PlatformSectionHeader title="조회 조건" description="계정 활성화 여부를 기준으로 관리자 목록을 조회합니다." collapsible open={isConditionOpen} onToggle={() => setIsConditionOpen(prev => !prev)}/>
      {isConditionOpen && <BoardSearchDetail>
        <RowSpan>
          <ColSpan1>
            <ColTitle><span>활성화 여부</span></ColTitle>
            <Select styles={adminSelectStyle}
                    options={accountUseYnState}
                    placeholder={'선택'}
                    value={searchAccountInfoState.activeYn !== ''  ? accountUseYnState.find(type => type.value === searchAccountInfoState.activeYn) : accountUseYnState[0]}
                    onChange={handleSelectAccountUseYn}
                    isSearchable={false}
            />
          </ColSpan1>
        </RowSpan>
        <AdminConditionFooter>
          <AdminConditionActions>
            <AdminResetButton type="button" onClick={resetSearchCondition}>초기화</AdminResetButton>
            <AdminApplyButton type="button" onClick={()=>searchUserList()}>적용</AdminApplyButton>
          </AdminConditionActions>
        </AdminConditionFooter>
      </BoardSearchDetail>}
    </AdminCard>
    <AdminCard>
      <PlatformSectionHeader
          title="관리자 목록"
          description="등록된 관리자 정보와 계정 상태를 확인합니다."
          count={totalInfo.totalCount ?? 0}
          unit="명"
          action={<AdminAddAction><CreateAdminModal formType="admin" title="관리자 추가" buttonText="관리자 추가"/></AdminAddAction>}
      />
      <AdminListBody>
        <Table columns={adminColumns}
               data={userInfoList !== null ? userInfoList : []}
               onRowClick={handleAdminRowClick}/>
      </AdminListBody>
    </AdminCard>
      </AdminManageCards>
  )
}
const AdminManageCards = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
`;

const AdminCard = styled.section`
  position: relative;
  z-index: ${({$condition}) => $condition ? 10 : 1};
  overflow: ${({$condition}) => $condition ? "visible" : "hidden"};
  border: 1px solid #e5e8eb;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 5px 18px rgba(31, 41, 55, 0.045);
`;

const AdminListBody = styled(BoardSearchResult)`
  padding: 18px 20px 20px;
  border: 0 !important;
  background: #fff;

  && .InovuaReactDataGrid,
  && .inovua-react-toolkit-table {
    border: 0 !important;
    border-radius: 0;
    box-shadow: none !important;
  }

  && .InovuaReactDataGrid__row {
    cursor: pointer;
  }

  && > section > div:last-child {
    border: 1px solid #e5e8eb !important;
    border-radius: 8px !important;
    box-shadow: none !important;
  }

`;

const AdminAddAction = styled.div`
  button {
    min-width:104px;height:40px;padding:0 16px;border:1px solid #f1d4c2;
    border-radius:6px;background:#fff4e8;color:#f5811f;font-size:var(--font-size-14);font-weight:600;
    box-shadow:none;cursor:pointer;
  }
  button:hover {border-color:#f1d4c2;background:#ffe8d2;color:#f5811f;}
  button:focus-visible {outline:3px solid rgba(245,129,31,.24);outline-offset:2px;}
`;
const RowSpan = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 12px;
  margin-top: 0;
`

 const ColSpan1 = styled.div`
  position: relative;
  display: flex;
  align-items: stretch;
  width: 280px;
  flex-direction: column;
  gap: 8px;
  & > div:last-child {
    position: relative;
    width: 100%;
  }
`

 const ColSpan2 = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 50%;
  gap: 10px;
  & > div:last-child {
    position: relative;
    width: 100%;
  }
`

 const ColSpan3 = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 75%;
  gap: 10px;
  & > div:last-child {
    position: relative;
    width: 100%;
  }
`

 const ColSpan4 = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  & > div:last-child {
    position: relative;
    width: 100%;
  }
`

 const ColFraction = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  width: auto;
  gap: 10px;
  & > div:last-child {
    position: relative;
    width: 100%;
  }
`
 const ColTitle = styled.div`
  padding: 0;
  min-width: 0;
  color: #555;
  font-size: var(--font-size-13);
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
`
const BoardSearchDetail = styled.div`
  min-height: 112px;
  box-sizing: border-box;
  padding: 22px 24px 26px;
  border: 0;
  background: #fff;

  ${RowSpan} {
    margin-top: 0;
  }

`

const AdminConditionActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;

const AdminConditionFooter = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 16px;
`;

const AdminResetButton = styled.button`
  && {
    min-width: 72px;
    height: 36px;
    padding: 0 12px;
    border: 1px solid #dfe3e7;
    border-radius: 6px;
    background: #fff;
    color: #666;
    font-size: var(--font-size-13);
    font-weight: 600;
    cursor: pointer;
  }
  &&:hover {border-color:#f1d4c2;background:#fffaf6;color:#f5811f;}
`;

const AdminApplyButton = styled.button`
  && {
    display: inline-flex;
    min-width: 72px;
    height: 36px;
    align-items: center;
    justify-content: center;
    padding: 0 14px;
    border: 1px solid #f5811f;
    border-radius: 6px;
    background: #fff4e8;
    color: #f5811f;
    font-size: var(--font-size-13);
    font-weight: 700;
    cursor: pointer;
  }
  &&:hover:not(:disabled) {background:#ffe8d2;color:#f5811f;}
  &&:disabled {border-color:#ddd;background:#f5f5f5;color:#aaa;cursor:not-allowed;}
`;
